import { render, staticRenderFns } from "./SecurityAudit.vue?vue&type=template&id=6601dd39&scoped=true"
import script from "./SecurityAudit.vue?vue&type=script&lang=js"
export * from "./SecurityAudit.vue?vue&type=script&lang=js"
import style0 from "./SecurityAudit.vue?vue&type=style&index=0&id=6601dd39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6601dd39",
  null
  
)

export default component.exports